const mediaCategories = [
  { value: "banner", label: "Banner Image" },
  { value: "offer-image", label: "Offer Image" },
  { value: "offer-video", label: "Offer Video" },
  { value: "homepage-slider", label: "Homepage Slider" },
  { value: "team-photo", label: "Team Photo" },
  { value: "testimonial-video", label: "Testimonial Video" },
  { value: "promo-banner", label: "Promotional Banner" },
  { value: "other-media", label: "Other Media" },
];

export default mediaCategories;
